<div class="flex flex-col justify-between h-full">
	<div class="flex flex-col gap-2 flex-1 overflow-auto">
		<div class="flex justify-between items-center">
			<span class="text-lg mb-2">ID Import from Treefort</span>
			<app-dropdown
				[ngModel]="selectedTreefortIdUrl?.value"
				(onSelect)="setSelectedTreefortIdUrl($event)"
				[itemGroups]="[{ items: treefortIdUrls }]"
				class="max-h-24 flex max-w-220"
				name="treefort-id-url-dropdown"
			>
			</app-dropdown>
		</div>
		<div class="flex text-sm gap-4">
			<app-id-details
				class="w-1/2"
				[(identification)]="treefortId"
				[isSecondId]="isSecondId"
			></app-id-details>

			<div
				class="flex justify-between flex-auto w-1/2"
				[ngClass]="{
					'border-2 border-grey-veryLight flex items-center justify-center':
						!treefortId?.[selectedTreefortIdUrl?.key],
				}"
			>
				<app-matter-url-pdf-viewer
					*ngIf="treefortId?.[selectedTreefortIdUrl?.key]"
					[googleSrcUrl]="treefortId?.[selectedTreefortIdUrl?.key]"
					[showMultiple]="true"
				></app-matter-url-pdf-viewer>
				<div
					*ngIf="!treefortId?.[selectedTreefortIdUrl?.key]"
					class="flex flex-1 flex-col items-center text-lg"
				>
					<img
						class="max-w-[50%] h-auto self-center"
						src="/assets/images/empty-states/empty-id.svg"
						alt="contact-card"
					/>
					<span class="mt-8">No ID on File</span>
				</div>
			</div>
		</div>
	</div>

	<div class="flex justify-between mt-4">
		<app-button size="small" btn="clear" (onClick)="back()">Back</app-button>

		<div class="flex gap-x-4">
			<app-button size="small" btn="secondary" (onClick)="skip()"
				>Skip</app-button
			>
			<app-button size="small" btn="primary" (onClick)="confirm()">{{
				buttonText
			}}</app-button>
		</div>
	</div>
</div>
